declare var $: any;

// import base stylesheets
import "stylesheets/base/reset"
import "stylesheets/base/general"

// import partials stylesheets
import "stylesheets/partials/header";
import "stylesheets/partials/footer";
import "stylesheets/partials/investment-advice";
import "stylesheets/partials/production-calc";
import "stylesheets/partials/prognosis";
import "stylesheets/partials/new-project";
import "stylesheets/partials/start-page";
import "stylesheets/partials/journey-menu";
import "stylesheets/partials/sub-step-menu";
import "stylesheets/partials/general-info";
import "stylesheets/partials/land";
import "stylesheets/partials/incomplete-steps-warning";
import "stylesheets/partials/procurement-model-page.scss";
import "stylesheets/partials/house-model-page.scss";
import "stylesheets/partials/landscape-construction-page";
import "stylesheets/partials/report";
import "stylesheets/partials/admin-ref-houses";
import "stylesheets/partials/alert";
import "stylesheets/partials/list-projects";
import "stylesheets/partials/list-reports";
import "stylesheets/partials/project";
import "stylesheets/partials/content-page";
import "stylesheets/partials/account-page";

// import component stylesheets
import "stylesheets/components/buttons";
import "stylesheets/components/text-boxes";
import "stylesheets/components/checkboxes";
import "stylesheets/components/spinner";
import "stylesheets/components/integer-input";
import "stylesheets/components/label";
import "stylesheets/components/radiobuttons";
import "stylesheets/components/houses-component";
import "stylesheets/components/land-component";
import "stylesheets/components/reference-house-selector";
import "stylesheets/components/foldout";
import "stylesheets/components/tables";

// import legacy css
// TODO remove!
import "stylesheets/Site";

// import print css last
import "stylesheets/base/print"

// import view-specific scripts
import { InvestmentAdvice } from "./partials/investmentAdvice";
import { Land } from "./partials/land";
import { InvestmentSupport } from "./partials/investmentSupport";
import { Navigation } from "./partials/navigation";
import { ProductionCalculation } from "./partials/productionCalculation"
import { Prognosis } from "./partials/prognosis"
import { ProcurementModel } from "./partials/procurementModel"
import { PrognosisGraph } from "./partials/prognosisGraph"
import { Project } from "./partials/project"
import { ProjectList } from "./partials/projectList"
import { AdminRefHouses } from "./partials/adminRefHouses"
import { StartPage } from "./partials/startPage"

// import component scripts
import { IntegerInput } from "./components/integerInput";
import { HousesComponent } from "./components/housesComponent";
import { HelpBoxComponent } from "./components/helpBoxComponent";
import { Foldout } from "./components/foldout";

// import module scripts
import { Autosave } from "./modules/autosave"
import { Print } from "./modules/print"
import { TextInput } from "./modules/textInput"

$(document).ready(() => {
    IntegerInput.init();
    HousesComponent.init();
    Navigation.init();
    Autosave.init();
    HelpBoxComponent.init();
    Foldout.init();
    Print.init();
    TextInput.init();
});

// This object will be available in the global scope as "App"
export {
    InvestmentAdvice, Land, InvestmentSupport,
    ProductionCalculation, Prognosis, ProcurementModel, PrognosisGraph,
    Project, ProjectList, AdminRefHouses, StartPage
}



// WEBPACK FOOTER //
// ./assets/scripts/app.ts